import {createFileRoute} from '@tanstack/react-router'
import {firstLevelIndexRoute} from "../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/cwg/browse/$primarySorting/')({
    ...firstLevelIndexRoute("/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName"),
});
